import { GetCohortsResponse } from "@performyard/service-contracts";

import request from "./internal-base-request";

/**
 * Get the current specific in-app promotion for the company
 * @param promotionId The key identifying the promotion is the promotionId.
 * @returns Response is an object with the promotion details
 */

export const getCohorts = async (cohortStatus: string) => {
	const [response] = await request<GetCohortsResponse>(`/v1/engagement/cohorts/${cohortStatus}`);

	const processedCohorts = response?.cohorts.map((cohort) => {
		return {
			...cohort,
			createdAt: new Date(cohort.createdAt),
			updatedAt: new Date(cohort.updatedAt),
			...(cohort?.archivedAt ? { archivedAt: new Date(cohort.archivedAt) } : {}),
		};
	});

	const { maximumAllowedCohorts, currentCohortCount } = response;

	return { cohorts: processedCohorts, maximumAllowedCohorts, currentCohortCount };
};

/**
 * Archives a cohort. This does not actually delete the cohort, but it
 * updates the archived_at property.
 */
export const archiveCohort = async (cohortID: string) => {
	const [data] = await request<{ success: boolean }>(`/v1/engagement/cohorts/archive`, {
		body: JSON.stringify({
			cohortID,
		}),
		method: "POST",
	});

	return data;
};

/**
 * Reactivates a cohort. This does not actually delete the cohort, but it
 * updates the archived_at property.
 */
export const reactivateCohort = async (cohortID: string) => {
	const [data] = await request<{ success: boolean }>(`/v1/engagement/cohorts/reactivate`, {
		body: JSON.stringify({
			cohortID,
		}),
		method: "POST",
	});

	return data;
};

/**
 * Deletes a cohort. This will mark the cohort as deleted.
 */
export const deleteCohortInternalAPI = async (cohortID: string) => {
	const [data] = await request<{ success: boolean }>(`/v1/engagement/cohorts/delete`, {
		body: JSON.stringify({
			cohortID,
		}),
		method: "DELETE",
	});

	return data;
};
